import { alpha, useTheme } from '@mui/material/styles';
import { Avatar, Box, Card, CardContent, Grid, ListItem, ListItemAvatar } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';

const mock = [
	{
		headerSlide: 'Why can Personalized Coaching help?',
		avatar: 'https://ezcareclinic.io/wp-content/uploads/2022/04/EZCare-Support-F-2-4.png.webp',

		subSlideLine1: 'Parental oversight is the single-biggest factor in a child’s development.',
		subSlideLine2: 'However, even the best intending parents often fall short when preparing on their own.',
		subSlideLine3: 'A coach handholds and gives careful, customized guidance to ensure there are no mistakes',
		subSlideLine4: '',
		subSlideLine5: '',

		headerBodySlide: 'A parental education course helps to:',

		bodySlideLine1: 'Be a well-informed parent',
		bodySlideLine2: 'Equip you, the parent, with the necessary skills',
		bodySlideLine3: 'Intentionally drive consistency and structure at home and in therapy',
		bodySlideLine4: '',
		bodySlideLine5: '',

		LinkForBodyLine1: '',
		LinkForBodyLine2: '',
		LinkForBodyLine3: '',
		LinkForBodyLine4: '',
		LinkForBodyLine5: '',

		CTAType1: 'CTA',
		CTAText1: 'Book a spot',
		CTALink1: '/contact'
	},

	{
		headerSlide: 'Why choose SimSouls for personalized parental coaching?',
		avatar: 'https://www.helpguide.org/wp-content/uploads/man-communicating-intently-with-woman.jpg',

		subSlideLine1:
			'We are parents to neuro-divergent children ourselves, and understand your exact needs.Furthermore,  who believe that not just a child, but every parent too, is different.',
		subSlideLine2:
			'Our parental coach, a BCBA, offers timely and personalized guidance for parents to quickly learn & adapt for the changing needs of your precious one.',
		subSlideLine3: 'As a parent, your specific needs, styles and preferences is our top priority.',
		subSlideLine4: '',

		headerBodySlide: 'Our sessions are:',

		bodySlideLine1:
			'Tuned to specific neuro diverse conditions, age-groups, background etc. to ensure personalization',
		bodySlideLine2:
			'are a combination of standard-schedule and on-call availability of coaches to cover you at all times.',
		bodySlideLine3: 'Administered by a dedicated support team to let you focus on what matters most',
		bodySlideLine4: 'Driven by highly qualified, professional experts trained as coaches, not just caregivers.',
		bodySlideLine5: '',

		LinkForBodyLine1: '',
		LinkForBodyLine2: '',
		LinkForBodyLine3: '',
		LinkForBodyLine4: '',
		LinkForBodyLine5: '',

		CTAType1: 'INFO',
		CTAText1: 'Learn More',
		CTALink1: '/contact'
	}
];

const ParentCoachingDescription = () => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				position: 'relative',
				boxShadow: 0,
				'&::after': {
					position: 'absolute',
					content: '""',
					width: '30%',
					zIndex: 1,
					top: 0,
					right: 0,
					height: '100%',
					backgroundSize: '18px 18px',
					backgroundImage: `radial-gradient(${alpha(theme.palette.primary.dark, 0.4)} 20%, transparent 20%)`,
					opacity: 0.2
				}
			}}>
			<Box position={'relative'} zIndex={2} paddingTop={4} marginX={{ xs: 2, sm: 2, md: 2 }}>
				<Box paddingX={1} marginY={0} paddingY={0}>
					<Box
						marginX={'auto'}
						paddingX={'auto'}
						marginY={0}
						paddingY={0}
						sx={{
							height: { xs: 'auto', md: 1 },
							'& .slick-slide img': {
								objectFit: 'cover'
							},
							'& .slick-list, & .slick-slider, & .slick-track, & .slick-slide > div': {
								height: { xs: 'auto', md: 1 }
							},
							'& .slick-dots': {
								marginTop: { xs: 19, sm: 7, md: 7, lg: 8 },
								top: { xs: '84%', sm: '90%', md: '87%' },
								height: '25px'
							},
							'& .slick-prev': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '0%',
								marginLeft: 0,
								marginRight: '32px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							},
							'& .slick-next': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '100%',
								marginLeft: '62px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							}
						}}>
						<Box>
							{mock.map((item, i) => (
								<Box key={i}>
									<Card
										sx={{
											display: 'flex',
											flexDirection: {
												xs: 'column',
												md: (i + 1) % 2 === 0 ? 'row' : 'row-reverse'
											},
											boxShadow: 0,
											background: 'transparent'
										}}>
										<CardContent
											sx={{
												display: 'flex',
												alignItems: 'left',
												marginLeft: { sx: 0, md: 2 }
											}}>
											<Box>
												<Box marginBottom={2}>
													<SimTypography variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
														{item.headerSlide}
													</SimTypography>

													<SimTypography color='text.primary'>
														{item.subSlideLine1 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine1}</Box>
														)}
														{item.subSlideLine2 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine2}</Box>
														)}
														{item.subSlideLine3 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine3}</Box>
														)}
														{item.subSlideLine4 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine4}</Box>
														)}
														{item.subSlideLine5 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine5}</Box>
														)}
													</SimTypography>
												</Box>

												<Grid container spacing='2px'>
													<SimTypography>
														{item.headerBodySlide === '' ? (
															<Box>
																{' '}
																<br />
															</Box>
														) : (
															<Box> {item.headerBodySlide} </Box>
														)}
													</SimTypography>

													{[
														{ line: item.bodySlideLine1, link: item.LinkForBodyLine1 },
														{ line: item.bodySlideLine2, link: item.LinkForBodyLine2 },
														{ line: item.bodySlideLine3, link: item.LinkForBodyLine3 },
														{ line: item.bodySlideLine4, link: item.LinkForBodyLine4 },
														{ line: item.bodySlideLine5, link: item.LinkForBodyLine5 }
													].map((item2, i2) => (
														<Grid item xs={12} key={i2}>
															<Box
																component={ListItem}
																disableGutters
																width={'auto'}
																padding={0}
																margin={0}
																display={'flex'}
																flexDirection={'row'}
																alignItems={'flex-start'}
																justifyItems={'left'}>
																{item2.line === '' ? (
																	<Box></Box>
																) : (
																	<Box
																		display={'flex'}
																		flexDirection={'row'}
																		alignItems={'center'}
																		justifyItems={'center'}>
																		<Box
																			component={ListItemAvatar}
																			minWidth={'auto !important'}
																			marginRight={2}
																			marginTop={'0.7em'}>
																			<Box
																				component={Avatar}
																				bgcolor={theme.palette.secondary.main}
																				width={20}
																				height={20}>
																				<svg
																					width={12}
																					height={12}
																					xmlns='http://www.w3.org/2000/svg'
																					viewBox='0 0 20 20'
																					fill='currentColor'>
																					<path
																						fillRule='evenodd'
																						d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
																						clipRule='evenodd'
																					/>
																				</svg>
																			</Box>
																		</Box>
																	</Box>
																)}

																<SimTypography padding={'8px'}>
																	{item2.line}
																</SimTypography>
															</Box>
														</Grid>
													))}
												</Grid>

												<Box display={'flex'} justifyContent={'flex-end'}>
													<SimButton
														variant='contained'
														backgroundColor={
															item.CTAType1 === 'CTA'
																? theme.palette.background.btnPrimaryCTA
																: theme.palette.background.btnSecondaryCTA
														}
														color={
															item.CTAType1 === 'CTA'
																? theme.palette.text.btnPrimaryCTA
																: theme.palette.text.btnSecondaryCTA
														}
														href={item.CTALink1}>
														{item.CTAText1}
													</SimButton>
												</Box>
											</Box>
										</CardContent>
									</Card>
								</Box>
							))}
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export { ParentCoachingDescription };
